import React from 'react';
import { Helmet } from '@vuer-ai/react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to projects page (or login if not authenticated)
    navigate('/projects', { replace: true });
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Studio Vault</title>
        <meta
          name="description"
          content="Share, collaborate, and securely backup your music projects in the cloud with Studio Vault"
        />
      </Helmet>
      <div>
        <main>
          <h1>Welcome to Studio Vault</h1>
          <p>
            Share, collaborate, and securely backup your music projects in the
            cloud with ease.
          </p>
        </main>
      </div>
    </>
  );
};

export default HomePage;
